export default __webpack_public_path__ + "maps-examples-default-callout-thumbnail-960-10586af1d81b20087d6f615825f0ba2e.png";